<template>
  <div data-testid="order-failed-page" class="px-4 md:px-0">
    <div class="border border-1 border-neutral-200 mt-10 mb-20 rounded p-4 md:p-6 flex flex-col items-center max-w-2xl mx-auto">
      <h1 class="mt-6 mb-6 text-2xl">{{ $t('Something went wrong') }}</h1>
      <SfButton :tag="NuxtLink" :href="localePath('/checkout')" class="max-md:w-full" variant="secondary">
        <template #prefix>
          <SfIconArrowBack />
        </template>
        {{ $t('Go to checkout') }}
      </SfButton>
      <SfButton :tag="NuxtLink" :href="localePath('/')" class="mt-4 max-md:w-full" variant="tertiary">
        {{ $t('Go back shopping') }}
      </SfButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { SfButton, SfIconArrowBack } from '@storefront-ui/vue';

const localePath = useLocalePath();
const NuxtLink = resolveComponent('NuxtLink');
</script>
